import { takeLatest,takeEvery,  put,  call } from "redux-saga/effects"

// new Password Redux States
import { RECRUITER_DETAIL_SET,RECRUITER_DETAIL_GET_COUNTRY,RECRUITER_DETAIL_GET_STATE,RECRUITER_DETAIL_GET_IP_LOCATION,RECRUITER_EDIT_PROFILE,RECRUITER_GET_PROFILE_DETAIL } from "./actionTypes"
import {  detailSetSuccess, detailSetError, detailSetCountrySuccess, detailSetCountryError, detailSetStateSuccess,detailSetStateError
  ,detailGetIpBasedLocationError,detailGetIpBasedLocationSuccess,
  profileSuccess,
  profileError,
  getProfileDataSucess, } from "./actions"
//Include Both Helper File with needed methods
import { 
  postDetailSet,
  getStates,
  getAllCounties,
  getIpLocation,
  postUpdateProfile,
  postProfileDetail } from "../../../../helpers/fakebackend_helper"

//restapi end point
import * as constClass from "../../../../common/constant/constantURL"

function* setDetail({ payload: { user,history } }) {
try{
     const response = yield call(postDetailSet, constClass.REST_API_RECRUITER_DETAIL, user)
     
     localStorage.setItem("authUser", JSON.stringify(response))
     yield put(detailSetSuccess(response))
     let redirectUrl = "/dashboard";
     if(!response.showRecruiterCompany){
     redirectUrl = "/recruiter/candidate/viewall"
       }
     history.push(redirectUrl)
}catch (error) {
    yield put(detailSetError(error))
  }

}
function* getCountries() {
  try {

    var url = constClass.REST_API_GET_COUNTRIES

    const response = yield call(getAllCounties, url)

    yield put(detailSetCountrySuccess(response))
   
  }
  catch (error) {
    yield put(detailSetCountryError(error))
  }
}

function* getState({ payload: { states } }) {
  try {
    var url = constClass.REST_API_GET_STATE

    const response = yield call(getStates, url, states)

    yield put(detailSetStateSuccess(response))

  }
  catch (error) {
    yield put(detailSetStateError(error))
  }
}

function* getIplocation() {
  try {
    var url = constClass.REST_API_GET_IP_LOCATION

    const response = yield call(getIpLocation, url)

    yield put(detailGetIpBasedLocationSuccess(response))

  }
  catch (error) {
    yield put(detailGetIpBasedLocationError(error))
  }
}

function* editProfile({ payload: { user, history } }) {
  try {
     if (process.env.REACT_APP_DEFAULTAUTH === "jwt") {

      // call update detail api
      var url = constClass.REST_API_RECRUITER_UPDATE_PROFILE_DETAIL

      const response = yield call(postUpdateProfile, url, user)
      yield put(profileSuccess(response))

      var obj = JSON.parse(localStorage.getItem("authUser"))
      obj.name=response.name
      obj.phoneNumber=response.phoneNumber
      obj.profileImage=response.profileImage
      localStorage.clear()

      localStorage.setItem("authUser", JSON.stringify(obj))
      localStorage.setItem("isAuthProtected", true)

    } 
    // history.push("/profile")
  } catch (error) {
    yield put(profileError(error))
  }
}
function* getProfileDetail({ payload: { user } }) {
  try {
    var url = constClass.REST_API_RECRUITER_GET_PROFILE_DETAIL+user
    const response = yield call(postProfileDetail, url, {
      userId: user,
    })
    yield put(getProfileDataSucess(response))
  }
  catch (error) {
    yield put(profileError(error))
  }
}

function* RecruiterDetailSaga() {
    yield takeEvery(RECRUITER_DETAIL_SET, setDetail)
    yield takeEvery(RECRUITER_DETAIL_GET_COUNTRY, getCountries)
    yield takeEvery(RECRUITER_DETAIL_GET_STATE, getState )
    yield takeEvery(RECRUITER_DETAIL_GET_IP_LOCATION, getIplocation )
    yield takeEvery(RECRUITER_EDIT_PROFILE, editProfile)
    yield takeLatest(RECRUITER_GET_PROFILE_DETAIL, getProfileDetail)
  }


  export default RecruiterDetailSaga